import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { CereriService } from 'src/app/components/cereri/cereri.service';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { environment } from 'src/environments/environment';
import { Observable, Subject, finalize, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialog.service';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { Generic, GenericStatusCerere } from 'src/app/interfaces/generic.interface';
import { DataTableDirective } from 'angular-datatables';
import { helper } from 'src/environments/helper';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import * as $ from 'jquery';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { ICerereListDT } from './cereri.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Router } from '@angular/router';
import { AppFilesService } from 'src/app/services/app-files.service';
import { CommonService } from 'src/app/services/common.service';
import { AddCerereComponent } from './add-cerere/add-cerere.component';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-cereri',
    templateUrl: './cereri.component.html',
    styleUrls: ['./cereri.component.scss'],
})
export class CereriComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;
    editorConfig!: AngularEditorConfig;
    isLoading = false;
    isFilterLoading = false;
    showCard = false;

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';

    // Last day of the current year
    lastDayOfYear: Date = new Date(new Date().getFullYear(), 11, 31);
    lastDayOfNextYear: Date = new Date(new Date().getFullYear() + 1, 11, 31);

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setToday(): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `today`;
    }

    setNextXDays(numberOfDays: number): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        const date = new Date();
        date.setDate(this.today.getDate() + numberOfDays);
        this.selectedEndDate = date;
        this.updateCalendarView(this.endCalendar, date);
        this.rerenderDT();
        this.selectedFilteringButton = `next_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = this.lastDayOfYear;
        this.updateCalendarView(this.endCalendar, this.lastDayOfYear);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    setTodayToEndYear(): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        this.selectedEndDate = this.lastDayOfYear;
        this.updateCalendarView(this.endCalendar, this.lastDayOfYear);
        this.rerenderDT();
        this.selectedFilteringButton = 'today_to_end_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    // Date popover filtering

    dateFilteringOptions: { id: number; value: string }[] = [
        { id: 1, value: 'Adăugare' },
        { id: 2, value: 'Actualizare' },
        { id: 3, value: 'Validare' },
        { id: 4, value: 'Invalidare/Anulare' },
        // { id: 5, value: 'Finalizare' },
        { id: 5, value: 'Programare Eveniment' },
        { id: 6, value: 'Programare Depunere' },
    ];

    dateFilterOption: number = 1;

    statusParametersValue!: string;
    categoryParametersValue!: string;
    notificationParameter: { id: string; name: string } = { id: '-1', name: '' };

    // Values for status filtering

    defaultParameter: { name: string; id: number } = {
        name: 'Toate',
        id: -1,
    };

    filterParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    validationParameters: { name: string; id: number }[] = [
        { name: 'Toate', id: -1 },
        { name: 'Validată', id: 1 },
        { name: 'Invalidată', id: 2 },
        { name: 'Anulată', id: 3 },
        { name: 'Necesită atenție', id: 4 },
    ];

    // Vaue for status filtering
    selectedStatusID: number = this.defaultParameter.id;

    // Values for category filtering
    categoryToggleOptions = [
        { id: -1, value: 'Toate' },
        // { id: 1, value: 'De aprobat' },
        { id: 1, value: 'Departamentele mele' },
        { id: 2, value: 'Cererile mele' },
        { id: 3, value: 'Mesaje interne' },
    ];

    selectedCategory: string | number = this.categoryToggleOptions[0].id;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    statusuriCerere!: GenericStatusCerere[];
    compartimente!: Generic[];
    requestTypes$!: Observable<Generic[]>;
    operatori$!: Observable<Generic[]>;
    locatii!: Generic[];

    parameters: { key: string; value: string }[] = [
        { key: '-- Alegeți --', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    searchParamsForm!: FormGroup;

    //Form Initial Values
    initialFormValues = {
        id_cerere_type: -1,
        id_category: -1,
        id_cerere: '',
        nume_cetatean: '',
        cnp_cetatean: '',
        email_cetatean: '',
        validated: -1,
        responsible_id: -1,
        id_locatie: -1,
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            id_cerere_type: new FormControl(-1),
            id_category: new FormControl(-1),
            id_cerere: new FormControl(''),
            nume_cetatean: new FormControl(''),
            cnp_cetatean: new FormControl(''),
            email_cetatean: new FormControl(''),
            validated: new FormControl(-1),
            responsible_id: new FormControl(-1),
            id_locatie: new FormControl(-1),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT(true);
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.deps.cerere.listDT;

    notificationServiceBefore: any = {
        currentStatus: -1,
        currentCategory: -1,
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService,
        public commonService: CommonService,
        private router: Router,
        private appFileService: AppFilesService,
    ) {
        this.tomorrow.setDate(this.today.getDate() + 1);
    }

    ngOnInit(): void {
        this.renderDT();
        this.loadCerereStatuses();
        this.loadCompartimente();
        this.loadLocatii();

        this.editorConfig = initializeEditor();
        this.buildSearchParamsForm();
        // this.redirectFromNotifications();
        this.filterCategoryOptions();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    // redirectFromNotifications() {
    //     this.notificationService.currentNotification.subscribe(
    //         (notification: { id: string; name: string }) => {
    //             if (notification) {
    //                 this.notificationParameter = notification;
    //                 // here we need to update our buttons
    //                 this.notificationServiceBefore.currentStatus = this.selectedStatusID;
    //                 this.notificationServiceBefore.currentCategory = this.selectedCategory;

    //                 this.selectedStatusID = '-1';
    //                 this.selectedCategory = -1;

    //                 this.rerenderDT();
    //             }
    //         }
    //     );
    // }

    removeChip(): void {
        // Resets the notification parameter which we send to our backend with -1 so the filter for this particular flag is canceled
        this.notificationParameter = { id: '-1', name: '' };

        // here we need to update our buttons
        this.selectedStatusID = this.notificationServiceBefore.currentStatus;
        this.selectedCategory = this.notificationServiceBefore.currentCategory;

        this.rerenderDT();
    }

    loadCerereStatuses() {
        this.isFilterLoading = true;
        this.commonService
            .getCerereStatusesActive()
            .pipe(
                map((results: any) => [...results, this.defaultParameter]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusuriCerere = results;
                },
                error: (error) => {
                    console.error('Error loading request statuses', error);
                    this.isFilterLoading = false;
                },
            });
    }

    loadCompartimente() {
        this.isFilterLoading = true;
        this.commonService
            .getCompartimenteByDeps()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.compartimente = results;
                },
                error: (error) => {
                    console.error('Error loading compartimente by deps', error);
                    this.isFilterLoading = false;
                },
            });
    }

    onCompartimenteChange(compartimentId: number): void {
        this.searchParamsForm.controls['id_cerere_type'].patchValue(-1);
        this.searchParamsForm.controls['responsible_id'].patchValue(-1);

        if (compartimentId > 0) {
            this.loadCerereTypes(compartimentId);
            this.loadOperatori(compartimentId);
        } else {
            this.requestTypes$ = new Observable<Generic[]>((observer) => {
                observer.next([this.defaultParameter])
                observer.complete();
            });
            this.operatori$ = new Observable<Generic[]>((observer) => {
                observer.next([])
                observer.complete();
            });
        }
    }

    loadCerereTypes(compartimentId: number) {
        this.isFilterLoading = true;
        this.requestTypes$ = this.commonService
            .getCerereTypesByComp(compartimentId)
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => { this.isFilterLoading = false })
            );
    }

    loadOperatori(id_compartiment: number) {
        this.isFilterLoading = true;
        this.operatori$ = this.cereriService
            .getOperatoriByCompartiment(id_compartiment)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            );
    }

    loadLocatii() {
        this.isFilterLoading = true;
        this.commonService.getLocatii().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isFilterLoading = false))
        ).subscribe({
            next: (results) => {
                this.locatii = results;
            },
            error: (error) => {
                console.error('Error loading locatii', error);
                this.isFilterLoading = false;
            },
        });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, 'desc']],

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                dataTablesParameters.id_cerere_status = this.selectedStatusID;
                dataTablesParameters.id_cerere_priority = this.selectedCategory;
                // dataTablesParameters.filters = {
                //     ...this.searchParamsForm.value,
                // };
                dataTablesParameters.tip_date = +this.dateFilterOption;
                dataTablesParameters.date_from = this.formatDate(
                    this.selectedStartDate
                );
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);
                // dataTablesParameters.notification = this.notificationParameter.id;
                dataTablesParameters.notification = 0;

                dataTablesParameters.id_category = this.searchParamsForm.value.id_category;
                dataTablesParameters.id_cerere_type = this.searchParamsForm.value.id_cerere_type;
                dataTablesParameters.id_cerere = this.searchParamsForm.value.id_cerere;
                dataTablesParameters.nume_cetatean = this.searchParamsForm.value.nume_cetatean;
                dataTablesParameters.cnp_cetatean = this.searchParamsForm.value.cnp_cetatean;
                dataTablesParameters.email_cetatean = this.searchParamsForm.value.email_cetatean;
                dataTablesParameters.validated = this.searchParamsForm.value.validated;
                dataTablesParameters.responsible_id = this.searchParamsForm.value.responsible_id;
                dataTablesParameters.id_locatie = this.searchParamsForm.value.id_locatie;

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });

                        if (resp.data.recordsFiltered < dataTablesParameters.start) {
                            this.rerenderDT(true);  // sets dataTablesParameters.start = 0, goes to page 1
                        }
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                // { width: '30px', targets: 0 },
                { width: '100px', targets: 9 },
            ],

            columns: [
                {
                    title: 'ID',
                    data: 'id_cerere',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        let flagIcon = '<i class="fa-solid fa-flag" style="color: white;"></i> ';

                        let source = '';
                        let color = '';
                        switch (row.source) {
                            case 1:
                                source = 'WEB';
                                color = '#06b706';
                                break;
                            case 2:
                                source = 'EMAIL';
                                color = '#0000FF';
                                break;
                            case 3:
                                source = 'MOBILE';
                                color = '#ffa500';
                                break;
                            case 4:
                                source = 'PORTAL';
                                color = '#800080';
                                break;
                            default:
                                source = '';
                                break;
                        }
                        return `
                            <div style="display: flex; flex-direction: column; gap: 5px;">
                                <span>${row.id_cerere}</span>
                                <span style="color: ${color}; font-weight: 700;">${source}</span>
                            </div>
                        `;
                        // return `
                        //     <div style="display: flex; flex-direction: row; gap: 5px;">
                        //         <span>${row.id_cerere}</span>
                        //         <span style="color: ${color}; font-weight: 700;">${source}</span>
                        //     </div>
                        //     <br/>
                        // 	` + (row.mesajeInterne == 1 ?
                        //         `<div style="display:inline-block; padding: 4px 6px; color: white; background-color: red; border: 0px;border-radius:10px">
                        //                 <span>${flagIcon} Mesaj intern</span>
                        //             </div>`
                        //         : '')
                        //     + `
                        // `;
                    },
                },
                {
                    title: 'Subiect',
                    data: 'subject',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        return `${row.subject}`
                    }
                },
                {
                    title: 'Cetățean',
                    data: 'fullname',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        const name = row.fullname !== (null || "" || " ") ? row.fullname : 'n/a';
                        return `<span>${name}</span>`
                    }
                },
                {
                    title: 'Categorie/tip',
                    data: 'section',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<span>${row.section}</span>`
                    }
                },
                {
                    title: 'Departament',
                    data: 'category',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        return `<span>${row.category}</span>`
                    }
                },
                {
                    title: 'Dată creat',
                    data: 'created_at',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `${row.created_at}`
                    }
                },
                {
                    title: 'Prioritate/SLA',
                    data: 'sla',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        // <span>${row.time}</span><br/><br/>
                        return `
                                <span style="border-radius:10px; padding:4px 8px; color: ${row.priority_color}; background: ${row.priority_bg_color}">${row.priority_name}</span><br/><br/>
                    			<span style="color:#bdbdbd; font-size:12px">SLA</span><br/>
                    			<span>${row.sla}</span><br/>
                    		`;
                    },
                },
                {
                    title: 'Responsabil',
                    data: 'user_assigned_name',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<span>${row.user_assigned_name || 'n/a'}</span>`
                    }
                },
                {
                    title: 'Creator',
                    data: 'user_submit_name',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<span>${row.user_submit_name || 'n/a'}</span>`
                    }
                },
                {
                    title: 'Status',
                    data: 'status',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        let label = '';
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';
                        if (row.validated_date && !row.cancel_date) {
                            // Validat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: green">${flagIcon}Validat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 1) {
                            // Invalidat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: orange">${flagIcon}Invalidat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 2) {
                            // Clasat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: red">${flagIcon}Clasat</span>`;
                        } else {
                            // Default case
                            label = ``;
                        }
                        return `
                            <span style="border-radius:10px; padding:4px 8px; color: ${row.status_color}; background: ${row.status_bg_color}">${row.status_name}</span>
                            <br/><br/>
                            ${label}
                        `;
                    }
                },
                {
                    title: 'Actualizat',
                    data: 'updated_at',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `${row.updated_at || 'n/a'}`
                    }
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data);
                });

                return row;
            },
        };
    }

    onRowClick(rowData: ICerereListDT) {
        this.openInfoDialog(rowData);
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    openInfoDialog(data: ICerereListDT) {
        const dialogRef = this.dialog.open(CereriDetaliiComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                cerere: data,
            },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.rerenderDT();
        });
    }

    openAddDialog() {

        const dialogRef = this.dialog.open(AddCerereComponent, {
            ...this.dialogService.getDialogConfigMD()
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Cerere adaugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    onStatusChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.selectedStatusID = event.value;

        this.statusParametersValue = event.value === 'toate' ? '-1' : '1';
        this.rerenderDT();
    }

    onCategoryChange(event: MatButtonToggleChange) {
        this.isLoading = true; // Assuming you have an isLoading flag for loading state
        this.selectedCategory = event.value;

        const selectedOption = this.categoryToggleOptions.find(option => option.id === event.value);
        this.categoryParametersValue = selectedOption ? selectedOption.value : 'default';
        this.rerenderDT();
    }

    filterCategoryOptions() {
        const permissionMapping: { [key: string]: string } = {
            "-1": "deps-module.cerere.list-all",
            // "1": "deps-module.cerere.to-approve",
            "1": "deps-module.cerere.list-my-departments",
            "2": "deps-module.cerere.list-my-requests",
            "3": "deps-module.cerere.list-intern-messages",
        };

        // Filter categoryToggleOptions based on permissions
        this.categoryToggleOptions = this.categoryToggleOptions.filter(option =>
            this.permissionsService.hasPermission(permissionMapping[option.id.toString()])
        );

        // Initialize selectedCategory after filtering
        this.selectedCategory = this.categoryToggleOptions[0]?.id;
    }

    onDateFilterChange(): void {
        this.rerenderDT();
    }

    redirectTo(): void {
        const slug = 'someString';
        this.router.navigate([slug]);
    }
}
